module.exports = __webpack_public_path__ + "static/media/box.f274f1a4.png";